export default __webpack_public_path__ + "static/media/elia.d06f6f0b.jpg";